import React, { useState, useEffect } from 'react'
import { useQueryParams } from 'raviger'
import { colors } from 'Constants'

import { getReport, getReportLevel } from '../helpers'

import { Flex } from 'lese'
import ScaleLoader from 'react-spinners/ScaleLoader'
import ReportTitle from '../components/ReportTitle'
import ReportHeader from '../components/ReportHeader'
import Section from 'Components/Section'
import DoctorReport from './components/DoctorActivityReport'

export default ({ appCode }) => {
  const [
    { startDate, endDate, officeId, patientRef, showArchivedOffices },
    setQuery
  ] = useQueryParams()
  const [reports, setReports] = useState([])
  const [loading, setLoading] = useState(true)

  const title = getReportLevel(officeId, patientRef)

  useEffect(async () => {
    setReports(
      await getReport('/reports/activity/get', {
        appCode,
        startDate,
        endDate,
        officeId,
        patientRef,
        showArchivedOffices
      })
    )
    setLoading(false)
  }, [])

  return (
    <>
      <ReportTitle
        title={`${title} Activity Report`}
        csvUrl="/reports/activity/csv"
        appCode={appCode}
      />
      {loading && (
        <Flex xAlign yAlign height="70vh">
          <ScaleLoader color={colors.secondary} loading={loading} />
        </Flex>
      )}
      {reports.map(report => (
        <>
          <ReportHeader
            header="Office"
            title={report.title}
            cardValues={[
              ['Total', 'Patients', report.totalPatients],
              ['Total Active', 'Patients', report.totalActivePatients],
              ['Total Not Started', 'Patients', report.totalInactivePatients],
              ['Total New Active', 'Patients', report.totalNewPatients],
              ['Total Reported', 'Alerts', report.flags]
            ]}
          />
          <ReportHeader
            header=""
            title=""
            cardValues={Object.keys(report.totalPatientByGroup).map(item => [
              'Group: ' + item,
              'Patients',
              report.totalPatientByGroup[item]
            ])}
          />
          {Object.values(report.doctorsByGroup).length === 0 && (
            <div
              style={{
                textAlign: 'center',
                padding: '16px 0',
                margin: '16px 0',
                borderBottom: `1px solid ${colors.borderColor}`
              }}
            >
              There are no items in this office
            </div>
          )}
          {Object.keys(report.doctorsByGroup).map(group => {
            return (
              <>
                <div
                  style={{
                    padding: '10px 5px',
                    backgroundColor: `${colors.activity}`,
                    color: `${colors.textOnPrimary}`
                  }}
                >
                  <Section header="Group" title={group} />
                </div>
                {Object.values(report.doctorsByGroup[group]).map(doctor => (
                  <DoctorReport doctor={doctor} />
                ))}
              </>
            )
          })}
        </>
      ))}
    </>
  )
}
